import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Configuration for the first Firebase project (tiffofood-admin) WEB
const firebaseConfig = {
  apiKey: "AIzaSyD9moGcIG2nHYqfMk6P1ML_lKuaIBLW6QM",
  authDomain: "tiffofood-admin.firebaseapp.com",
  projectId: "tiffofood-admin",
  storageBucket: "tiffofood-admin.firebasestorage.app",
  messagingSenderId: "507277021288",
  appId: "1:507277021288:web:3e4caf8dd62a6a0983ebdd",
  measurementId: "G-WBKWMLJRFL"
};


const app = initializeApp(firebaseConfig, 'tiffofood-admin');
export const auth = getAuth(app);
export const db = getFirestore(app);